exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "body {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: sans-serif;\r\n}\r\n", "", {"version":3,"sources":["W:/projects/brownfield/src/W:/projects/brownfield/src/index.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,WAAW;EACX,wBAAwB;CACzB","file":"index.css","sourcesContent":["body {\r\n  margin: 0;\r\n  padding: 0;\r\n  font-family: sans-serif;\r\n}\r\n"],"sourceRoot":""}]);

// exports
